module.exports = __webpack_public_path__ + "static/media/SCHAALKLEURSTOF_03.346222e4.png";